import { ContentLoader, Input, Label } from "@trussle/external-components";
import React from "react";
import {
  Control, Controller, UseFormRegisterReturn, UseFormSetValue,
} from "react-hook-form";
import classNames from "classnames";
import { IRateWatchPanelFormValues } from ".";

export interface IInputsProps {
    setValue: UseFormSetValue<IRateWatchPanelFormValues>;
    endDateMethods: UseFormRegisterReturn<"endDate">;
    monthsUntilRemo: number;
    monthSupported?: boolean;
    endDate: Date | null;
    control: Control<IRateWatchPanelFormValues, any>;
    loading: boolean;
}

const classOverrides = {
  input: "rate-watch-panel__input",
  inputContainer: "rate-watch-panel__input",
};

export interface IControlledProps {
  control: Control<IRateWatchPanelFormValues, any>
  name: "repayment" | "balance" | "propertyValue";
  label: string;
  inputSize?: "small" | "large" | "x-large";
}
const Controlled: React.FC<IControlledProps> = ({
  control, name, label, inputSize,
}) => (
  <Controller
    control={control}
    name={name}
    render={({
      field: {
        onChange, onBlur, value, name, ref,
      },
    }) => (
      <Input
        label={label}
        variant="currency"
        value={value!}
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        classOverrides={classOverrides}
        inputSize={inputSize}
        id={name}
      />
    )}
  />
);

export const Inputs: React.FC<IInputsProps> = ({
  setValue, endDateMethods, monthsUntilRemo, monthSupported, endDate, control, loading,
}) => (
  <div className="rate-watch-panel__inputs-wrapper">
    <div className={classNames({
      "rate-watch-panel__inputs__left__loading": loading,
    })}
    >
      <Label title="Your target monthly repayment:" className="rate-watch-panel__repayment-label" htmlFor="repayment" />
      {loading
        ? (
          <ContentLoader classOverrides={{ contentLoader: "rate-watch-panel__inputs__loader__repayment" }} />
        )
        : <Controlled control={control} name="repayment" label="" inputSize="x-large" />}
    </div>
    <div className="rate-watch-panel__secondary-inputs">
      <p className="rate-watch-panel__inputs-titles">Fill-in empty fields below:</p>
      <div className="rate-watch-panel__secondary-inputs-wrapper">
        <div>
          {loading ? <ContentLoader classOverrides={{ contentLoader: "rate-watch-panel__inputs__loader__date" }} /> : (
            <Input
              {...endDateMethods}
              label={monthSupported ? "Product end date" : "Product end date (MM/YYYY)"}
              variant="month"
              monthSupported={monthSupported}
              onChange={(e) => {
                if (monthSupported) {
                  endDateMethods.onChange(e);
                } else {
                  // Otherwise it doesn't work with the library used to only allow specific characters/autoformat dates
                  setValue("endDate", e.target.value as any);
                }
              }}
              id="endDate"
              classOverrides={{
                additionalTextContainer: "rate-watch-panel__secondary-inputs-month-error",
                ...classOverrides,
              }}
            />
          )}
          <p className="rate-watch-panel__secondary-inputs-months-left">
            {endDate && monthsUntilRemo >= 0 ? `${monthsUntilRemo} month${monthsUntilRemo !== 1 ? "s" : ""} left` : ""}
          </p>
        </div>
        {loading
          ? <ContentLoader classOverrides={{ contentLoader: "rate-watch-panel__inputs__loader__balance" }} />
          : <Controlled control={control} name="balance" label="Outstanding balance" />}
        {loading
          ? <ContentLoader classOverrides={{ contentLoader: "rate-watch-panel__inputs__loader__propertyValue" }} />
          : <Controlled control={control} name="propertyValue" label="Property value" />}
      </div>
    </div>
  </div>
);
